<script>
import Button from "@/shared/ui/button/Button.vue";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/shared/ui/dialog";
import { Textarea } from "@/shared/ui/textarea";

export default {
  name: "DialogWrapper",
  components: {
    Button,
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    Textarea,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "520px",
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "update:content", "close", "save"],
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    textContent: {
      get() {
        return this.content;
      },
      set(value) {
        this.$emit("update:content", value);
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    },
  },
};
</script>

<template>
  <Dialog :open="visible" @update:open="visible = $event">
    <DialogContent :style="{ maxWidth: width }" @close="closeDialog">
      <DialogHeader>
        <DialogTitle>{{ $t(title) }}</DialogTitle>
      </DialogHeader>

      <Textarea
        v-model="textContent"
        :rows="4"
        :placeholder="$t(title)"
        class="min-h-32 resize-none"
      />

      <DialogFooter>
        <Button @click="closeDialog" variant="outline">
          {{ $t("Отмена") }}
        </Button>
        <Button variant="default" :disabled="disableSave" @click="save">
          {{ $t("Сохранить") }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<style scoped lang="scss"></style>
